import { useCallback, useState } from "react";

import { CURRENT_USER } from "../constants";
import { CustomerUser } from "../models/customer.user";

export default function useCurrentCustomerUser() {
  const [currentCustomerUser, _setCurrentCustomerUser] = useState<CustomerUser | undefined>(
    window.localStorage.getItem(CURRENT_USER)
      ? JSON.parse(window.localStorage.getItem(CURRENT_USER) || "")
      : undefined
  );

  const setCurrentCustomerUser = useCallback((user?: CustomerUser) => {
    if (user) {
      window.localStorage.setItem(CURRENT_USER, JSON.stringify(user));
    } else {
      window.localStorage.removeItem(CURRENT_USER);
    }
    _setCurrentCustomerUser(user);
  }, []);

  return [currentCustomerUser, setCurrentCustomerUser] as const;
}
